<template>
    <BaseForm v-if="project">
        <template #fields>
            <MultiLink
                :label="$t('other-links')"
                :links="values.otherLinks"
                :error-messages="errors.otherLinks"
                @input="setFieldValue('otherLinks', $event)"
                @delete="setFieldValue('otherLinks', $event)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectInjection } from '@/project/composables/useProjectInjection';
import { ProjectOtherLinksSchema } from '@/project/schemas';
import { computed } from 'vue';

const { project, createProjectMultiLink } = useProjectInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createProjectMultiLink);

const otherLinksId = computed(() => project.value?.otherLinks?.id);
const otherLinksLinks = computed(() => project.value?.otherLinks?.links.nodes ?? []);

const { values, errors, setFieldValue, validate, onDiscard, resetForm } = useForm(
    ProjectOtherLinksSchema,
    computed(() => ({
        otherLinks: getFormFieldLinks(otherLinksLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: otherLinksId.value, fieldName: 'otherLinks', links: values.value.otherLinks },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
